'use client';
import { isHex, isRGBA, isRGB } from '../validators/validators.js';

function hexToRgba(color) {
    var hexString = color.replace("#", "");
    if (hexString.length === 3) {
        var shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    var parsed = parseInt(hexString, 16);
    var r = parsed >> 16 & 255;
    var g = parsed >> 8 & 255;
    var b = parsed & 255;
    return {
        r: r,
        g: g,
        b: b,
        a: 1
    };
}
var parseRGBA = function(color) {
    var _color_replace_split_map = color.replace(/[^0-9,.]/g, "").split(",").map(Number), r = _color_replace_split_map[0], g = _color_replace_split_map[1], b = _color_replace_split_map[2], a = _color_replace_split_map[3];
    return {
        r: r,
        g: g,
        b: b,
        a: a || 1
    };
};
var toRGBA = function(color) {
    if (isHex(color)) {
        return hexToRgba(color);
    }
    if (isRGBA(color) || isRGB(color)) {
        return parseRGBA(color);
    }
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
};

export { toRGBA };
